export default __webpack_public_path__ + "static/assets/9b8a0ee6ed4746d6ee0d948410f5e0bc.svg";